var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c("h1", { domProps: { textContent: _vm._s(_vm.errorMessage) } }),
      _vm._v(" "),
      _c("NuxtLink", { attrs: { to: "/" } }, [_vm._v("\n    Home page\n  ")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }